import { useAlerts } from './AlertContext';

export const useAlertHelpers = () => {
    const { addAlert } = useAlerts();

    return {
        showSuccess: (message, options = {}) =>
            addAlert({ type: 'success', message, ...options }),

        showError: (message, options = {}) =>
            addAlert({ type: 'error', message, ...options }),

        showInfo: (message, options = {}) =>
            addAlert({ type: 'info', message, ...options }),

        showWarning: (message, options = {}) =>
            addAlert({ type: 'warning', message, ...options })
    };
};